import { render, staticRenderFns } from "./PcPassword.vue?vue&type=template&id=0a881806&scoped=true"
import script from "./PcPassword.vue?vue&type=script&lang=js"
export * from "./PcPassword.vue?vue&type=script&lang=js"
import style0 from "./PcPassword.vue?vue&type=style&index=0&id=0a881806&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a881806",
  null
  
)

export default component.exports